import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import VmView from './components/vmView/VmView';
import VmLanding from './components/vmLanding/VmLanding';
import { isRunningInDiscord } from './DiscordUtils';

function Root(){
  return <>404 Not Found</>
}

function VmOnlyUnderDiscord(){
  if (isRunningInDiscord()){
    return <VmView/>;
  }else{
    return <Root/>;
  }
}

function App() {
  return(
    <BrowserRouter>
    <Routes>
      <Route path="/" element={<VmOnlyUnderDiscord/>}/>
      <Route path="/app" element={<VmView/>}/>
      <Route path="/hello" element={<VmLanding/>}/>
    </Routes>
    </BrowserRouter>
  )
}

export default App;
